export const testimonials = [
  {
    id: 1,
    name: "Maria S.",
    location: "Boca Raton, FL",
    service: "Roof Cleaning",
    rating: 5,
    text: "The roof looks incredible — like we just built the house. Fast, professional, and worth every penny. Neighbors kept asking us what we did. Highly recommend Total Residential Solution!"
  },
  {
    id: 2,
    name: "James R.",
    location: "Delray Beach, FL",
    service: "Driveway Pressure Cleaning",
    rating: 5,
    text: "Our driveway had years of oil stains and mold. After one visit it looked brand new. The team was on time, efficient, and left zero mess behind. These guys are the real deal in South Florida."
  },
  {
    id: 3,
    name: "Patricia W.",
    location: "Coral Springs, FL",
    service: "Screen Patio Cleaning",
    rating: 5,
    text: "HOA was on our case about the patio screen. Called Total Residential Solution and they came out next day. The screen patio is spotless and we passed inspection with zero issues. Amazing service!"
  },
  {
    id: 4,
    name: "Carlos M.",
    location: "Boynton Beach, FL",
    service: "Full Exterior + Gutter Cleaning",
    rating: 5,
    text: "Hired them for the full package — house exterior, roof, and gutters. Everything exceeded my expectations. Very detailed, professional crew, and the price was fair. Won't use anyone else."
  },
  {
    id: 5,
    name: "Susan L.",
    location: "West Palm Beach, FL",
    service: "Roof Cleaning",
    rating: 5,
    text: "I was shocked by the before and after. The dark streaks on my roof made it look 20 years old. After the cleaning it looks like new construction. Couldn't be happier — 5 stars!"
  },
  {
    id: 6,
    name: "David T.",
    location: "Pompano Beach, FL",
    service: "Pressure Cleaning",
    rating: 5,
    text: "Quick response, honest pricing, and outstanding results. The team was thorough and professional from start to finish. My property looks fantastic and I couldn't be more pleased."
  }
];
